const endPoint = process.env.VUE_APP_API_BASE_URL
const endPointV2 = process.env.VUE_APP_API_BASE_URL_V2
const endPointV3 = process.env.VUE_APP_API_BASE_URL_V3
// const endPoint = 'https://www.atnbookingengine.com/api'
// const endPointV2 = 'https://www.atnbookingengine.com/v2/api'
// const endPointV3 = 'https://www.atnbookingengine.com/v3/api'

// app currency
export const currencies = `${endPoint}/getCurrencies`
// auth
export const login = `${endPointV3}/auth/login`
export const register = `${endPointV3}/auth/register`
export const logout = `${endPointV3}/auth/logout`
export const verify = `${endPointV3}/auth/email/verify`
export const resend = `${endPointV3}/auth/email/resend`
export const resetPasswordCode = `${endPointV3}/auth/reset-password-code`
export const resetPassword = `${endPointV3}/auth/reset-password`
export const approveEmail = (token) => `${endPointV3}/auth/approve-user?token=${token}`
export const forceChangePassword = `${endPointV3}/auth/force-change-password`
export const profile = () => `${endPoint}/user/profile`
export const userBookings = `${endPoint}/user/bookings`
// flights
export const getAirlines = (term) => `${endPointV2}/flights/airlines/autocomplete?term=${term}`
export const getAirports = (term) => `${endPoint}/airport/autocomplete?term=${term}`
export const searchFlights = (term) => `${endPoint}/flights/search?${term}`
export const getFlight = (id, search, relatedFlightId) => {
  if (relatedFlightId) return `${endPoint}/flights?flight_id=${id}&search_id=${search}&related_flight_id=${relatedFlightId}`
  else return `${endPoint}/flights?flight_id=${id}&search_id=${search}`
}
export const getOffices = () => `${endPoint}/offices/list`
export const createPNR = `${endPoint}/pnr/create`
export const showPNR = (pnr) => `${endPoint}/pnr/${pnr}`
export const bookFlightByMail = `${endPointV2}/flights/send-special-offer-request-mail`
export const cancelFlight = `${endPoint}/user/bookings/cancel-flight`
export const updatePassportInfo = `${endPoint}/user/subAgent/flights/booking/update-passport-info`
// cars
export const carSearch = (term) => `${endPoint}/cars/search?${term}`
export const showCar = (term) => `${endPoint}/cars/show?${term}`
export const rentCar = `${endPoint}/cars/book`

// hotels
export const getCities = (term) => `${endPoint}/cities/autocomplete?term=${term}`
export const searchHotels = (term) => `${endPoint}/hotels/search?${term}`
export const getHotel = (sessionId, hotelIndex, hotelCode) => `${endPoint}/hotels/show?sessionId=${sessionId}&hotelIndex=${hotelIndex}&hotelCode=${hotelCode}`
export const hotelAvailability = (term) => `${endPoint}/hotels/roomsAvailabilityAndPricing?${term}`
export const bookHotel = `${endPoint}/hotels/book`
// headers
export function headersNoAuth () {
  return { Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://reservations.bellavistatours.com' }
}
export function headersAuth (token) {
  return { Authorization: 'Bearer ' + token, Accept: 'application/json', 'Content-type': 'application/json', Application: 'https://reservations.bellavistatours.com' }
}
// https://reservations.bellavistatours.com
// https://bellavista-dev.adamtravel.net
